<template>
  <div
    v-editable="item && !item.isGlobal"
    class="relative flex items-center justify-center"
  >
    <span v-if="item.labelBefore">{{ item.labelBefore }}</span>
    <a
      v-if="item.sectionLink"
      :href="`#${item.sectionLink}`"
      class="link"
      :class="classes"
      @click="(e) => handleLinkClick(e)"
    >
      <span class="relative">
        {{ item.labelLink }}

        <span
          v-if="item.displayVacanciesCounter && siteVacanciesTotal"
          class="font-bolder absolute -top-1.5 -right-4 flex h-[1.15rem] w-[1.15rem] items-center justify-center rounded-full bg-red-500 align-middle text-[0.6rem] text-white"
          >{{ siteVacanciesTotal }}</span
        >
      </span>
    </a>
    <a
      v-else-if="isLocalLink || item.externalLinkUrl"
      :href="link"
      class="link"
      :class="classes"
      @click="(e) => handleLinkClick(e)"
    >
      <span class="relative">
        {{ item.labelLink }}

        <span
          v-if="item.displayVacanciesCounter && siteVacanciesTotal"
          class="font-bolder absolute -top-1.5 -right-4 flex h-[1.15rem] w-[1.15rem] items-center justify-center rounded-full bg-red-500 align-middle text-[0.6rem] text-white"
          >{{ siteVacanciesTotal }}</span
        >
      </span>
    </a>
    <button v-else class="link" :class="classes" @click="handleClick">
      <span class="relative">
        {{ item.labelLink }}

        <span
          v-if="item.displayVacanciesCounter && siteVacanciesTotal"
          class="font-bolder absolute -top-1.5 -right-4 flex h-[1.15rem] w-[1.15rem] items-center justify-center rounded-full bg-red-500 align-middle text-[0.6rem] text-white"
          >{{ siteVacanciesTotal }}</span
        >
      </span>
    </button>
    <span v-if="item.labelAfter">{{ item.labelAfter }}</span>
  </div>
</template>

<script setup>
import { computed, onBeforeMount } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore } from '../store'
import ctaEventBus from '../ctaEventBus.js'
import handleHashLink from '../utils/handleHashLink'
import { useColorPalette } from '../composables/colorPalette'

const props = defineProps({
  item: {
    type: Object,
    default: () => {},
  },
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
  linkClass: {
    type: String,
    default: '',
  },
})

const store = useMainStore()
const { textColorClass } = useColorPalette()

const { siteVacanciesTotal } = storeToRefs(store)

const link = computed(() => {
  const link = props.item.externalLinkUrl
  if (!link) {
    return ''
  }
  if (/http/.test(link)) {
    // is external domain
    return link
  }
  // is same domain
  if (import.meta.env.VITE_IS_EDITOR) {
    // is editor
    if (link === '/') {
      return props.context && '/' + props.context.domainSlug
    }
    return props.context && '/' + props.context.domainSlug + link
  }
  // is not editor
  return link
})
const isLocalLink = computed(() => {
  return !/http/.test(props.item.externalLinkUrl) && !props.item.actionIntent
})
const classes = computed(() => {
  if (props.linkClass) return props.linkClass
  return textColorClass(props.item.linkTextColor || 'default')
})

function handleClick() {
  submitSoftApplyEvent()
  ctaEventBus.$emit(props.item.actionIntent)
}
function handleLinkClick(event) {
  submitSoftApplyEvent()
  handleHashLink(event, event.currentTarget)
}

function submitSoftApplyEvent() {
  if (window.dataLayer && props.item.actionIntent === 'vacancy-apply') {
    window.dataLayer.push({
      event: 'jrUniversalSoftApply',
    })
  }
}

onBeforeMount(() => {
  if (props.item.displayVacanciesCounter) {
    // We add a bit of time before making the request in case there's also a VacancyList block
    // in the page
    setTimeout(() => {
      store.getTotalSiteVacancies()
    }, 1000)
  }
})
</script>
